export const DEFAULT_LIST_INSTANCE_ID = 'classic';

// Allowlist für den `?list=`-Umleit-Pfad (Menü + Toolbar, Task 1.4): nur hier gelistete Module öffnen
// gespeicherte Listen im Workspace-Modus als eigenen, isolierten Tab. Jeder Phase-2-Task fügt sein Modul
// im selben Commit hinzu, der die jeweilige Surface auf `listInstanceId` verdrahtet — Phase 1 = nur noteList.
export const INSTANCED_LIST_MODULES = new Set([
	'documentList',
	'mailList',
	'messageList',
	'noteList',
	'phoneCallList',
	'taskList',
	'trashList',
]);

const LIST_INSTANCE_PREFIX = 'list:';
const CONTACT_SEARCH_INSTANCE_PREFIX = 'search:';
const STORE_ID_SEPARATOR = '#';

export const isDefaultInstance = (instanceId: string): boolean => instanceId === DEFAULT_LIST_INSTANCE_ID;

export const deriveListStoreId = (moduleRouteName: string, instanceId: string): string =>
	isDefaultInstance(instanceId) ? moduleRouteName : `${moduleRouteName}${STORE_ID_SEPARATOR}${instanceId}`;

export const deriveGenericListIdentifier = (moduleRouteName: string, instanceId: string): string =>
	deriveListStoreId(moduleRouteName, instanceId);

export const listInstanceIdFromSharedQueryId = (sharedQueryId: string): string =>
	`${LIST_INSTANCE_PREFIX}${sharedQueryId}`;

export const sharedQueryIdFromListInstanceId = (instanceId: string): null | string =>
	instanceId.startsWith(LIST_INSTANCE_PREFIX) ? instanceId.slice(LIST_INSTANCE_PREFIX.length) : null;

export const listInstanceIdFromContactSearchTerm = (searchTerm: string): string =>
	`${CONTACT_SEARCH_INSTANCE_PREFIX}${searchTerm}`;

export const contactSearchTermFromListInstanceId = (instanceId: string): null | string =>
	instanceId.startsWith(CONTACT_SEARCH_INSTANCE_PREFIX)
		? instanceId.slice(CONTACT_SEARCH_INSTANCE_PREFIX.length)
		: null;
